import React from 'react';

export const IconWatch: React.FC = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20.0007" cy="20.0002" r="15.9167" stroke="#15141D" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M18.334 11.6665V21.6665H28.334" stroke="#15141D" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
